import { SubcomponentConfig } from '@/features/equipment-browser/equipment-details/state/related-devices.state';
import { Stack } from '@/ux-common/components/stack/stack';
import { Typography } from '@/ux-common/components/typography/typography';

import { Subcomponent } from './subcomponent';

type SubcomponentSectionProps = {
  subcomponents: SubcomponentConfig[];
  title?: string;
};

export const SubcomponentSection = ({
  subcomponents,
  title,
}: SubcomponentSectionProps): React.ReactNode => {
  return (
    <Stack className="stack-thin">
      <Typography as="h4" className="text-header-card">
        {title}
      </Typography>
      {subcomponents?.map((subcomponent: SubcomponentConfig, index: number) => (
        <Subcomponent
          key={`subcomponents-${index}`}
          displayName={subcomponent.displayName}
          icon={subcomponent.icon}
          attributes={subcomponent.attributes}
        />
      ))}
    </Stack>
  );
};
